import { AnalyticsService } from '@hb/services/analytics/analytics.service';
import { QuestionKey } from '@hb/modules/global/global.constants';

import { FormControl, Validators } from '@angular/forms';
import { Observable, debounceTime, distinctUntilChanged, filter } from 'rxjs';

export class GlobalControl<T> extends FormControl<T> {
    state: T;
    constructor(
        readonly analyticsService: AnalyticsService,
        readonly key: QuestionKey,
        state: T
    ) {
        super(state, [Validators.required]);
        this.state = state;
        this.sendAnalyticsEvent();
    }

    onUpdate(): Observable<T> {
        return this.valueChanges.pipe(
            distinctUntilChanged(),
            filter(() => this.valid)
        );
    }

    private sendAnalyticsEvent(): void {
        this.valueChanges
            .pipe(
                filter(() => this.valid),
                filter((value) => value !== null),
                filter((value) => this.state !== value),
                distinctUntilChanged(),
                debounceTime(2000)
            )
            .subscribe((value) => {
                this.analyticsService.sendValueUpdate(this.key, value);
            });
        this.statusChanges
            .pipe(
                filter(() => !this.valid),
                filter(() => this.value !== null)
            )
            .subscribe(() => this.analyticsService.sendErrorState(this.key, this.value.toString()));
    }
}
